export const tipos_campos_personalizados = [
    { value: "destinatarios", label: "Cliente"},
    { value: "bodega", label: "Bodega"},
    { value: "contacto", label: "Contacto"},
]

